<div
  class="section"
>
  <h2>Invite Someone to Join Motion</h2>

  <div class="invite-form">
    <div>
      <input
        [(ngModel)]="inviteeName"
      >
      <div class="label">
        Invitee Name
      </div>
    </div>

    <div>
      <input
        [(ngModel)]="inviteeEmail"
      >
      <div class="label">
        Invitee Email Address
      </div>
    </div>
  </div>

  <button
    (click)="sendInvite()"
    [ngClass]="{
      'green': 1,
      'loading': sendingInvite,
      'inactive': !inviteeName || !inviteeEmail
    }"
  >
    <span>
      Send Invite
      <i class="fa-solid fa-paper-plane"></i>
    </span>
    <motn-spinner></motn-spinner>
  </button>
</div>

<div
  class="section"
>
  <h2>
    Invites Sent
    <motn-pill
    >Shown for 30 days</motn-pill>
  </h2>

  @if (rows) {
    <motn-sort-table
      [table$]="table$"
    ></motn-sort-table>
  }
</div>
